import React from 'react';
import FormControlFactory from '../components/FormControlFactory';
import FieldSetBuilder from '../components/FieldSetBuilder';
import { FormSettingsControls } from '../types/IFormSettings';

export function getFormChild(el: FormSettingsControls, formName: string, i: number) {
    if ('fieldSetName' in el) {
        return <FieldSetBuilder key={`${el.fieldSetName}-${i}`} {...el} formName={formName} />;
    }

    if ('grid' in el) {
        return null;
    }

    return <FormControlFactory key={`${el.controlName}-${i}`} {...el} formName={formName} />;
}
